import { isFunction } from '../isFunction';
import { isPlainObject } from '../isPlainObject';
import type { InstanceClone } from '../types';
import { clone } from './clone';

export function cloneObjectDeep<T>(
  value: T,
  instanceClone?: InstanceClone<T>,
): T {
  if (isFunction(instanceClone)) {
    return instanceClone(value);
  }

  if (instanceClone || isPlainObject(value)) {
    const cloned = new (value as any).constructor();

    for (const key in value) {
      cloned[key] = clone(value[key]);
    }

    return cloned;
  }

  return value;
}
